import { Card, HTMLTable } from "@blueprintjs/core";
import { css } from "glamor";
import * as _ from "lodash";
import * as React from "react";
import { getAllPasswords } from "src/api";
import { Password } from "src/Interfaces";

const styles = {
	container: css({ width: "100%" }),
	table: css({ width: "100%" }),
	tableRow: css({
		"@media print": {
			lineHeight: "100px",
			border: "1px solid black",
			fontSize: "30px",
		},
	}),
	tableHeader: css({
		"@media print": {
			display: "none",
		},
	}),
};

interface State {
	passwords: Password[];
}
export default class Passwords extends React.Component<{}, State> {
	public state = { passwords: [] as Password[] };

	public async componentDidMount() {
		const passwords = await getAllPasswords();
		if (!passwords) {
			return;
		}

		this.setState({ passwords });
	}
	public render() {
		const passwords = _.sortBy(this.state.passwords, "name");
		return (
			<div {...styles.container}>
				<Card>
					<HTMLTable striped={true} {...styles.table}>
						<thead {...styles.tableHeader}>
							<tr>
								<th>Fight</th>
								<th>Password</th>
							</tr>
						</thead>
						<tbody>
							{passwords.map((password) => (
								<tr key={password.id} {...styles.tableRow}>
									<td>{password.name}</td>
									<td>{password.password}</td>
								</tr>
							))}
						</tbody>
					</HTMLTable>
				</Card>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Backend/Passwords.tsx